__turbopack_context__.v({
  "acts": "tags-module__3v_naq__acts",
  "backCrumb": "tags-module__3v_naq__backCrumb",
  "caret": "tags-module__3v_naq__caret",
  "chips": "tags-module__3v_naq__chips",
  "column": "tags-module__3v_naq__column",
  "columnBody": "tags-module__3v_naq__columnBody",
  "count": "tags-module__3v_naq__count",
  "dialogError": "tags-module__3v_naq__dialogError",
  "dialogLine": "tags-module__3v_naq__dialogLine",
  "empty": "tags-module__3v_naq__empty",
  "factsInset": "tags-module__3v_naq__factsInset",
  "head": "tags-module__3v_naq__head",
  "headCount": "tags-module__3v_naq__headCount",
  "headMain": "tags-module__3v_naq__headMain",
  "items": "tags-module__3v_naq__items",
  "itemsHead": "tags-module__3v_naq__itemsHead",
  "main": "tags-module__3v_naq__main",
  "mark": "tags-module__3v_naq__mark",
  "path": "tags-module__3v_naq__path",
  "rail": "tags-module__3v_naq__rail",
  "tagPath": "tags-module__3v_naq__tagPath",
  "tree": "tags-module__3v_naq__tree",
  "treeRow": "tags-module__3v_naq__treeRow",
});
